<!-- eslint-disable max-len -->
<template lang="pug">
.text-area.text-start
  label.text-area-label.mb-2.p-small(:for='name') {{ label }} {{ requiredSymbol }}
  textarea(
    :row='rows',
    :placeholder='placeholder',
    :class='["form-control", errorLog ? "invalid" : "", overflowHidden ? "overflow-hidden" : "", resizable ? "" : "resize-none"]',
    :name='name',
    :id='name',
    :value='modelValue',
    :disabled='isDisabled',
    :style='`height:${size}px;`',
    @input='$emit("update:modelValue", $event.target.value)'
  )
  .invalid-feedback(v-if='!!errorLog')
    span.text {{ errorLog }}
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'TextArea',
    props: {
      rows: {
        type: String,
        default: '3',
      },
      placeholder: {
        type: String,
      },
      name: {
        type: String,
      },
      label: {
        type: String,
      },
      modelValue: {
        type: String,
      },
      isDisabled: {
        type: Boolean,
      },
      isRequired: {
        type: Boolean,
      },
      errorLog: {
        type: String,
      },
      size: {
        type: String,
      },
      resizable: {
        type: Boolean,
        default: true,
      },
      overflowHidden: {
        type: Boolean,
      },
    },
    computed: {
      getColorIcon() {
        if (this.$props.isDisabled) {
          return 'gray-dark'
        }

        if (this.$props.errorLog !== '') {
          return 'danger'
        }

        return 'primary'
      },
      requiredSymbol() {
        return this.$props.isRequired && this.$props.label ? '*' : ''
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .resize-none {
    resize: none;
  }
</style>
